// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"1d54f3fe","285":"b1ca61c1","858":"614188da"}[chunkId] + ".chunk.css";
};